import styled from '@emotion/styled';
import { RouterLink } from '../../../../../components/common/link/RouterLink';
import { ArrowLinkStyles } from '../../../../../components/common/button/ArrowLinkStyles';
import { Color } from '../../../../../styles/Color';
import { ICON_GAP_TRANSITION } from '../../../../../styles/animation/iconGapTransition';
import { IEnrichedFlight } from '../../../../flights/shared/flight/domain/models/IEnrichedFlight';
import { useFlightDetailUrl } from '../../../../flights/detail/ui/helpers/useFlightDetailUrl';
import {
	ChevronRightIcon,
	Responsive,
	VisuallyHidden,
} from '../../../../../ui';

interface IDetailsCellProps {
	flight: IEnrichedFlight;
	arrival: boolean;
}

export default function DetailsCell({ flight, arrival }: IDetailsCellProps) {
	const href = useFlightDetailUrl(flight);
	const text = arrival ? 'Arrival' : 'Departure';

	return (
		<StyledDetailsCell>
			<ArrivalText>{text}</ArrivalText>
			<StyledLink href={href}>
				Details
				<VisuallyHidden>
					for flight {flight.codeShareFlightNumber}
				</VisuallyHidden>
				<ChevronRightIcon />
			</StyledLink>
		</StyledDetailsCell>
	);
}

const StyledDetailsCell = styled.div`
	display: flex;
	height: 100%;
	flex-direction: column;
	justify-content: space-between;
`;

const ArrivalText = styled.span`
	color: ${Color.PrimaryBlue};

	display: none;
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: inline;
	}
`;

const StyledLink = styled(RouterLink)`
	${ArrowLinkStyles};
	display: flex;
	align-items: center;
	text-decoration: none;
	font-weight: 700;
	color: ${Color.PrimaryBlue1};

	& svg {
		transition: ${`transform ${ICON_GAP_TRANSITION}`};
		path {
			stroke: currentColor;
			stroke-width: 2;
		}
	}
`;
